export const defaultBuildingsQuery = {
	_limit: 25,
	_sortColumn: 'address',
	_sortDirection: 'asc',
	mapAreaType: 'city',
};

export const buildingsInclude = 'clients,contacts';

export const perPageVals = [5, 15, 25, 30, 60, 100, 200];

export const sortOptions = [
	{value: 'address', title: 'Address'},
	{value: 'manufacturingYear', title: 'Manufacturing year'},
	{value: 'zip', title: 'ZIP code'},
	{value: 'city', title: 'Municipality'},
];

export const buildingsFiltersKeys = [
	'encounterState',
	'dateFrom',
	'dateTo',
	'manufacturingYearStart',
	'manufacturingYearEnd',
	'unknownManufacturingYear',
	'onlyWithClientWithPhone',
	'onlyUnknownBuildings',
	'_street',
	'zip',
	'city',
	'municipalName',
	'_q',
	'areas',
	'tagIds',
	'uniqId',
	'types',
	'latestEncounterType',
	'latestEncounterState',
	'latestEncounterReasonMappingId',
	'latestEncounterStateFrom',
	'latestEncounterStateTo',
	'latestEncounterStateOrganizationId',
	'drawnPolygon',
	'products',
	'buildingProductStateEncounterStates',
	'hasClients',
	'hasContacts',
];

export const emptyBuildingsFilters = {
	encounterState: '',
	dateFrom: null,
	dateTo: null,
	manufacturingYearStart: null,
	manufacturingYearEnd: null,
	unknownManufacturingYear: false,
	onlyWithClientWithPhone: false,
	onlyUnknownBuildings: false,
	zip: null,
	_street: '',
	city: '',
	municipalName: '',
	q: '',
	areas: [],
	types: '',
	latestEncounterType: '',
	latestEncounterState: '',
	latestEncounterReasonMappingId: '',
	latestEncounterStateFrom: null,
	latestEncounterStateTo: null,
	latestEncounterStateOrganizationId: null,
	// Stores array values as comma separated string (not the most optimal way to do it BUT it saves us trouble of formatting/parsing input to/from api)
	tagIds: '',
	uniqId: null,
	drawnPolygon: '',
	products: [],
	buildingProductStateEncounterStates: '',
	hasClients: null,
	hasContacts: null,
};

export const massSelectionLimit = 15000;

export const csvUniqIdStorageKey = 'buildings.buildings.csvUniqId';
